"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6062],{

/***/ 8537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/views/parts/bases/Fixed.tsx
var Fixed = __webpack_require__(2624);
// EXTERNAL MODULE: ./src/views/parts/bases/VStack.tsx
var VStack = __webpack_require__(2326);
// EXTERNAL MODULE: ./src/views/parts/commons/GlobalNavigationHeader/Layout.tsx + 17 modules
var GlobalNavigationHeader_Layout = __webpack_require__(9275);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/views/parts/bases/HStack.tsx
var HStack = __webpack_require__(1078);
// EXTERNAL MODULE: ./src/views/parts/bases/Text.tsx
var Text = __webpack_require__(1695);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6835);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useHover.js + 1 modules
var useHover = __webpack_require__(8192);
// EXTERNAL MODULE: ./src/views/parts/bases/Clickable.tsx
var Clickable = __webpack_require__(269);
;// CONCATENATED MODULE: ./public/images/iconExternalLinkActive.png
/* harmony default export */ var iconExternalLinkActive = ({"src":"/_next/static/media/iconExternalLinkActive.5e338872.png","height":60,"width":60,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEUA++wA++xMaXEA++sA++sA++sA++sA++sA++sA++w1pl5bAAAACXRSTlMpPwCEjsG2ZAZt/LbiAAAACXBIWXMAACE4AAAhOAFFljFgAAAAM0lEQVQImSXJyQ3AMBDEMGn2sNN/wwESfkkQ5ML0cR+wEnrFDvN1Zcn5K2lhqroGgip5ARXIAJJ2wXMXAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconExternalLink.png
/* harmony default export */ var iconExternalLink = ({"src":"/_next/static/media/iconExternalLink.04496254.png","height":60,"width":60,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEX///////9MaXH///////////////////////////////+dDMdUAAAACnRSTlMpPgCEwYy2RWSWolWz7gAAAAlwSFlzAAAhOAAAITgBRZYxYAAAADRJREFUCJkly8cNACAQxEDvXiD0XzAIvh4ZM0AYsqZ6g8JmtVCZRK80np/sGpARFQlG0t0PF+AAoLT2rNkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(2120);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/views/parts/commons/GlobalMenuButton.tsx













var GlobalMenuButton = function GlobalMenuButton(props) {
  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useHover = (0,useHover/* default */.Z)(function (hovered) {
    var isActive = props.isActive || hovered;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Clickable/* Clickable */.P, {
      className: "w-full",
      disabled: props.disabled,
      onClick: props.onClick,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
        className: "w-full items-start rounded-lg p-3 transition-all ".concat(isActive || hovered ? 'bg-primary-textActive bg-opacity-10' : ''),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
          className: props.disabled ? 'opacity-40' : '',
          children: [props.activeIconUrl && props.normalIconUrl ? /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: isActive ? props.activeIconUrl : props.normalIconUrl,
            width: 20,
            height: 20,
            objectFit: "contain",
            alt: props.text
          }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
            className: "ml-2 items-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
              className: "text-sm font-bold ".concat(isActive ? 'text-primary-textActive' : 'text-white', " "),
              children: props.text
            }), props.isExtenalLink ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "ml-2 flex",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: isActive ? iconExternalLinkActive : iconExternalLink,
                width: "16px",
                height: "16px",
                objectFit: "contain",
                alt: "External Link Icon"
              })
            }) : null]
          })]
        }), props.commingSoon ? /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          className: "ml-8 text-sm font-semibold text-primary-textActive",
          children: t('Common.comingSoon')
        }) : null]
      })
    });
  }),
      _useHover2 = (0,slicedToArray/* default */.Z)(_useHover, 1),
      hoverable = _useHover2[0];

  return hoverable;
};
// EXTERNAL MODULE: ./public/images/akv.png
var akv = __webpack_require__(3076);
;// CONCATENATED MODULE: ./public/images/iconMyAKIVERSE.png
/* harmony default export */ var iconMyAKIVERSE = ({"src":"/_next/static/media/iconMyAKIVERSE.47ce69df.png","height":48,"width":48,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEX///////9MaXH////////////////////////////isepOAAAACnRSTlMM7wD+YrY/lx2KwPzkHQAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADNJREFUCJktxskNADAMAjAC5Np/4apq/TJYtl0EQhEK3Mz8dL94xjfK7hTATSmXIFlF8gAbYwDPwIgYiwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconMyAKIVERSEActive.png
/* harmony default export */ var iconMyAKIVERSEActive = ({"src":"/_next/static/media/iconMyAKIVERSEActive.36383d5e.png","height":48,"width":48,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJ1BMVEUA++wA++wA++xMaXEA++wA++wA++sA++sA++wA++sA++sA++sA+uv+tKRaAAAADXRSTlP+DO8Ak2I8ubIZIUJCqyMBoAAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADVJREFUCJktxskNwDAQAzF5R/KV9F9vYDh8UbxJ8qBWqlK1k73/2DdZKyea9lQTHtIwAnoHPh82ANr8Kj4vAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconGameCenter.png
/* harmony default export */ var iconGameCenter = ({"src":"/_next/static/media/iconGameCenter.b2c4fef8.png","height":48,"width":48,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEX///////9MaXH///////////////////////////////+dDMdUAAAAC3RSTlO6xQBKnxzQOu9DWRpdWpoAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA1SURBVAiZHcZJEoAwEAOxtj1Lwv8fTIFOwu6kbeySyqZr+BMBesz9gi7RzIzCcqoOizfdWb8Z6wDQtNYfewAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconGameCenterActive.png
/* harmony default export */ var iconGameCenterActive = ({"src":"/_next/static/media/iconGameCenterActive.d1ab1839.png","height":48,"width":48,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEUA++sA++sA+utMaXEA++wA++sA++wA++sA++sA++sA++sA++sbo+eyAAAADHRSTlO6xUkAnxzQPO+jWQW9GbzxAAAACXBIWXMAABYlAAAWJQFJUiTwAAAANklEQVQImSXGyQGAMBADsbG9RwL998sDvUTSdickJVVC16CbYAF63j9osWZmZJZTdViy7vbmAxxwANqR3MQXAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./public/images/iconArcade.png
var iconArcade = __webpack_require__(7885);
;// CONCATENATED MODULE: ./public/images/iconArcadeActive.png
/* harmony default export */ var iconArcadeActive = ({"src":"/_next/static/media/iconArcadeActive.17c29e3f.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJ1BMVEVMaXEA++wA++wA++wA++wA++wA++wA++wA++sA+uwA++wA++sA++z7CAvLAAAADHRSTlMA6ECUqVMaeNhmzMmNOQ8aAAAACXBIWXMAACE4AAAhOAFFljFgAAAANUlEQVQImS3Jxw3AMBAEsdkLtsL2X68hwT8ChNhZBdAN73Mwf0Rm3kpZI4DpJd1yl06F5QEfHFoA15HSJdwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconAkiverseWorld.png
/* harmony default export */ var iconAkiverseWorld = ({"src":"/_next/static/media/iconAkiverseWorld.44a82269.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEVMaXH///////////////////////////////////////8c1D1MAAAACnRSTlMAFtqbq4jFQ0ZCKZuUbQAAAAlwSFlzAAAhOAAAITgBRZYxYAAAADBJREFUCJkti7kRADAIw2zMk7D/wLkcqJEaAQCJIWLDbCNzfKT6Vru3gDIn3S525QMM7wB0qqERKQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconAkiverseWorldActive.png
/* harmony default export */ var iconAkiverseWorldActive = ({"src":"/_next/static/media/iconAkiverseWorldActive.a246a058.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEVMaXEA++sA++sA++wA++sA++sA++sA++sA++sA++wA++wFU33YAAAACnRSTlMAFtqbq4jFQ0ZCKZuUbQAAAAlwSFlzAAAhOAAAITgBRZYxYAAAADBJREFUCJkti7kRADAIw2zMk7D/wLkcqJEaAQCJIWLDbCNzfKT6Vru3gDIn3S525QMM7wB0qqERKQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconPlayerManager.png
/* harmony default export */ var iconPlayerManager = ({"src":"/_next/static/media/iconPlayerManager.da2925ea.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEX///9MaXH////////////+/v7////////AdE/PAAAAB3RSTlMSAN+4KLgGhWd/nwAAAAlwSFlzAAAhOAAAITgBRZYxYAAAACxJREFUCJlFi0EKADAIw9LW4f9/PATBSyikQRIMJJKhKLsQxN0OOx6n7rz5Bw+yAG8rNC26AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconPlayerManagerActive.png
/* harmony default export */ var iconPlayerManagerActive = ({"src":"/_next/static/media/iconPlayerManagerActive.25966ee1.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEUA++wA++wA++wA++xMaXEA++wA++zpp8UjAAAABnRSTlMSuN8BAChKT4zWAAAACXBIWXMAACE4AAAhOAFFljFgAAAALElEQVQImUWLQQoAMAzCorX9/5PHYKwXCSSSCtypIJEitN0E5BmLha82fvcDFjgAnS5tmMkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconDiscord.png
/* harmony default export */ var iconDiscord = ({"src":"/_next/static/media/iconDiscord.378ff825.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEX///////9MaXH///////////////////////////////////8ZR3RTAAAAC3RSTlMIVgDUnPHhjr6xbfIPYcYAAAAJcEhZcwAAITgAACE4AUWWMWAAAAA0SURBVAiZLYtBDgAgCMM2QBT2//8ajE3TW2GG7/YI3wbqQRxFZuhgLVRNpXyC3mQ7MevMFy5oAUloRdb4AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconDiscordActive.png
/* harmony default export */ var iconDiscordActive = ({"src":"/_next/static/media/iconDiscordActive.4afcf429.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJ1BMVEUA++tMaXEA++sA++sA++sA++wA++wA++wA++sA++sA++sA++sA++wqIHA4AAAADHRSTlMIAFrUt/HhjqGXT22a3d7RAAAACXBIWXMAACE4AAAhOAFFljFgAAAANUlEQVQImS2LSQ4AIAjEhkVQmP+/10hsmt4KEXzT9rYUKAeF80QcOtaCT8kYodZVbYq3vvkCMLoBYV3h9lQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconSupportCenter.png
/* harmony default export */ var iconSupportCenter = ({"src":"/_next/static/media/iconSupportCenter.e9b0064a.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEX////////////////////////////////////////////+/v7///////////8VO8iUAAAAD3RSTlMB/Q3muT1NXlerxsZ3Fyywu7LpAAAACXBIWXMAACE4AAAhOAFFljFgAAAAOElEQVQImRXLtwGAAAwEsXtnk/YfF+jUCLBuA0g/D08w986QUZJmVT/ikgpzRcgNVrFK4Llnvv4CIB0A8v8H08YAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconSupportCenterActive.png
/* harmony default export */ var iconSupportCenterActive = ({"src":"/_next/static/media/iconSupportCenterActive.6484b790.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAMFBMVEUA++sA++wA++xMaXEA++wA++sA++wA++sA++sA++sA++wA++sA+usA++sA++sA++wHi4WiAAAAD3RSTlMNtlsAAz1N9uHrxqV3LBfZU22MAAAACXBIWXMAACE4AAAhOAFFljFgAAAAPElEQVQImR3LSRLAMAgEsQYMeEky//+tq6K7GIE7MYhce68MWNPTGkotPypKskcqmDLThDDZ6QzG+/39AjXIAZP5MIlUAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconLogout.png
/* harmony default export */ var iconLogout = ({"src":"/_next/static/media/iconLogout.fe68403b.png","height":60,"width":60,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEX///////9MaXH///////////////////////////////////8ZR3RTAAAADHRSTlMQlQApqSUCjV9LxTwv4YFZAAAACXBIWXMAACE4AAAhOAFFljFgAAAALklEQVQImUWLxw0AMAyE8Lml7L9vXpF/SADCMx1BtJkF1L6SzOHEWtU5MOrHf38i6AD1m5hU+AAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/iconLogoutActive.png
/* harmony default export */ var iconLogoutActive = ({"src":"/_next/static/media/iconLogoutActive.3b771e78.png","height":60,"width":60,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEVMaXEA++wA++sA++sA++sA++sA++sA++sA+usA+usA++wA+ux9o5pBAAAADHRSTlMAD5UpqSWNXxRLxTxvBdPQAAAACXBIWXMAACE4AAAhOAFFljFgAAAAL0lEQVQImUWLSQ4AIAyEmC7W5f//9WLsjQQAeaYLZgwzC8E6gDnaUcXIhq86fvsFIDgA4UghcjsAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/qrcode.png
/* harmony default export */ var qrcode = ({"src":"/_next/static/media/qrcode.f9fdbff9.png","height":384,"width":384,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEXx5fz98f75/v7qoPv56/6jkseEm8Hr8/3Ew/v39/7g7vqZ1vyjc8PR0/9zqL+MtMa0icfm9/zgr/7m4/zl6Pz31P3s+/2I3PXFtfi0x/fZuv9SS1Wx0v/anvyZ2PWn2v/G6f9cYGBYYmA29VYWAAAAEXRSTlP+6en+/v7+/v7p/v7+/v7+/oPRsMIAAAAJcEhZcwAAITgAACE4AUWWMWAAAABESURBVAiZBcGFAYAwEASwA6r41xXbf0gSDJ4BsBp+6qYk5cBMP7nKEjBrraLNQOHvd9wEpE3sSyRYldtzRYJ2UlII4w+COwPpF2KdSgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/appStoreLogo.png
/* harmony default export */ var appStoreLogo = ({"src":"/_next/static/media/appStoreLogo.c6231615.png","height":48,"width":162,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEUICAkQEBEZLSwSLCwXNTQiIyQzMzQfOzprMHJwAAAAA3RSTlP9/P6lZlX3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVQImWNgYGViZmFmZGBgZGNiZ2FhZQAAAZQAMGLIy1IAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/images/playStoreLogo.png
/* harmony default export */ var playStoreLogo = ({"src":"/_next/static/media/playStoreLogo.71f61fc2.png","height":48,"width":162,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAHlBMVEUoJh8fOUUGBgY7MUIrKytFRUUbGxs+SyhQUE9aOyg4SZvmAAAABHRSTlP+/f77yGYAKgAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUCJljYGRnYGFhY2NiYOZkYOVgZWUBAAJKAEaBF7JvAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./src/views/parts/bases/Space.tsx
var Space = __webpack_require__(2952);
// EXTERNAL MODULE: ./src/views/parts/bases/Center.tsx
var Center = __webpack_require__(4582);
;// CONCATENATED MODULE: ./src/views/parts/commons/GlobalNavigationMenu/Layout.tsx
































var Layout_Layout = function Layout(props) {
  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
    className: "hidden_scroll_bar h-full w-full max-w-sm overflow-y-auto bg-menuBg",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
      className: "h-full w-full p-6 pb-3",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
        className: "h-16 w-full items-center rounded-xl border border-solid border-primary-textActive border-opacity-40 py-3 px-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: akv/* default */.Z,
          width: 30,
          height: 30,
          alt: "akv"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          className: "ml-3 flex-[0] text-sm font-bold text-primary-textActive",
          children: "AKV"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
          className: "ml-2 min-w-0 flex-1 items-end justify-end overflow-hidden text-ellipsis",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Text/* Text */.x, {
            className: "min-w-0 overflow-hidden text-ellipsis text-sm font-bold text-primary-textActive",
            children: ["$", "".concat(props.akvBalance)]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "my-5 min-h-[2px] w-full bg-gradient-to-r from-[#00FBEC00] via-[#00FBEC65] to-[#00FBEC00]"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
        className: "mb-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalMenuButton, {
          activeIconUrl: iconMyAKIVERSEActive,
          normalIconUrl: iconMyAKIVERSE,
          text: t('GlobalMenu.myAKIVERSEButton'),
          isActive: props.activeMenu === 'MyPage',
          onClick: props.onClickMyAkiverse,
          disabled: props.disabled
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
        className: "mb-2 w-full",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalMenuButton, {
          activeIconUrl: iconAkiverseWorldActive,
          normalIconUrl: iconAkiverseWorld,
          text: t('GlobalMenu.AkiverseWorldButton'),
          isActive: props.activeMenu === 'AkiverseWorld',
          onClick: props.onClickAkiverseWorld,
          disabled: props.disabled
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
        className: "mb-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalMenuButton, {
          activeIconUrl: iconGameCenterActive,
          normalIconUrl: iconGameCenter,
          text: t('GlobalMenu.gameCenterManagerButton'),
          isActive: props.activeMenu === 'GameCenterManager',
          onClick: props.onClickGameCenterManager,
          disabled: props.disabled
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
        className: "mb-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalMenuButton, {
          activeIconUrl: iconArcadeActive,
          normalIconUrl: iconArcade/* default */.Z,
          text: t('GlobalMenu.arcadeMachineManagerButton'),
          isActive: props.activeMenu === 'ArcadeMachineManager',
          onClick: props.onClickArcadeMachineManager,
          disabled: props.disabled
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
        className: "mb-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalMenuButton, {
          activeIconUrl: iconPlayerManagerActive,
          normalIconUrl: iconPlayerManager,
          text: t('GlobalMenu.PlayerManagerButton'),
          isActive: props.activeMenu === 'PlayerManager',
          onClick: props.onClickPlayerManager,
          disabled: true,
          commingSoon: true
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
        className: "my-2 text-xs font-bold text-white opacity-60",
        children: t('GlobalMenu.communitySectionLabel')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
        className: "mb-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalMenuButton, {
          activeIconUrl: iconDiscordActive,
          normalIconUrl: iconDiscord,
          text: t('GlobalMenu.DiscordButton'),
          onClick: props.onClickDiscord,
          isExtenalLink: true,
          disabled: props.disabled
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
        className: "mb-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalMenuButton, {
          activeIconUrl: iconSupportCenterActive,
          normalIconUrl: iconSupportCenter,
          text: t('GlobalMenu.SupportCenterButton'),
          onClick: props.onClickSupportCenter,
          isExtenalLink: true,
          disabled: props.disabled
        })
      }), props.isAdmin && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          className: "my-2 text-xs font-bold text-white opacity-60",
          children: t('GlobalMenu.admin.sectionLabel')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
          className: "mb-2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalMenuButton, {
            text: t('GlobalMenu.admin.bannerButton'),
            onClick: props.onClickBannerManager,
            disabled: props.disabled,
            isActive: props.activeMenu === 'BannerManager'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
          className: "mb-2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalMenuButton, {
            text: t('GlobalMenu.admin.interstitialBannerButton'),
            onClick: props.onClickInterstitialBannerManager,
            disabled: props.disabled,
            isActive: props.activeMenu === 'InterstitialBannerManager'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
          className: "mb-2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalMenuButton, {
            text: t('GlobalMenu.admin.tournamentButton'),
            onClick: props.onClickTournamentManager,
            disabled: props.disabled,
            isActive: props.activeMenu === 'TournamentManager'
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Space/* Space */.T, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Center/* Center */.M, {
        className: "flex-col rounded-xl border-[0.5px] border-solid border-akiverse-akir bg-black p-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          className: "text-center text-base font-bold text-akiverse-akir",
          children: t('GlobalMenu.getAppTitle')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
          className: "relative my-3 h-12 w-40",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://play.google.com/store/apps/details?id=io.akiverse.arcade",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: playStoreLogo,
              layout: "fill",
              alt: "go to google play"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
          className: "relative my-1 h-12 w-40",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: appStoreLogo,
            layout: "fill",
            alt: "go to app store"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
          className: "text-center text-base font-bold text-akiverse-akir",
          children: t('GlobalMenu.qrTitle')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
          className: "relative my-3 aspect-square w-32",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: qrcode,
            layout: "fill",
            alt: "qr"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-3 mt-8 min-h-[2px] w-full bg-gradient-to-r from-[#00FBEC00] via-[#00FBEC65] to-[#00FBEC00]"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
        className: "mb-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalMenuButton, {
          activeIconUrl: iconLogoutActive,
          normalIconUrl: iconLogout,
          text: t('GlobalMenu.LogoutButton'),
          onClick: props.onClickLogout,
          disabled: props.disabled
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/views/parts/commons/GlobalNavigationLayout/Layout.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var Layout = function Layout(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
    className: "min-h-screen w-full",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Fixed/* Fixed */.g, {
      className: "top-0 left-0 z-20 h-14 w-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalNavigationHeader_Layout/* Layout */.A, _objectSpread({}, props.GlobalNavigationHeaderProps))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Fixed/* Fixed */.g, {
      className: "top-0 left-0 z-20 h-screen w-72 pt-14",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout_Layout, _objectSpread({}, props.GlobalNavigationMenuProps))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
      className: "z-10 min-h-screen w-full flex-1 pt-14 pl-72",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
        className: "z-10 h-full w-full max-w-[1720px] flex-1",
        children: props.children
      })
    })]
  });
};

/***/ }),

/***/ 1373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ useProps; }
});

// EXTERNAL MODULE: ./src/views/parts/commons/GlobalNavigationHeader/useProps.ts
var GlobalNavigationHeader_useProps = __webpack_require__(2317);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/services/PagePathService.ts
var PagePathService = __webpack_require__(19);
// EXTERNAL MODULE: ./src/services/ExternalUrlService.ts
var ExternalUrlService = __webpack_require__(8106);
// EXTERNAL MODULE: ./src/services/AuthService.ts
var AuthService = __webpack_require__(746);
// EXTERNAL MODULE: ./src/views/states/LoginUser/index.tsx + 1 modules
var LoginUser = __webpack_require__(8655);
;// CONCATENATED MODULE: ./src/views/parts/commons/GlobalNavigationMenu/useProps.ts








var useProps_useProps = function useProps(_ref) {
  var activeMenu = _ref.activeMenu,
      disabled = _ref.disabled;
  var loginUser = (0,LoginUser/* useLoginUser */.x)().loginUser;
  var akvBalance = ''; // TODO

  var router = (0,next_router.useRouter)();
  var onClickGameCenterManager = (0,react.useCallback)(function () {
    return router.push(PagePathService/* PagePathService.gameCenterManager */.v.gameCenterManager());
  }, [router]);
  var onClickArcadeMachineManager = (0,react.useCallback)(function () {
    return router.push(PagePathService/* PagePathService.arcadeMachineManager */.v.arcadeMachineManager());
  }, [router]);
  var onClickAkiverseWorld = (0,react.useCallback)(function () {
    router.push(PagePathService/* PagePathService.akiverseWorld */.v.akiverseWorld());
  }, [router]);
  var onClickDiscord = (0,react.useCallback)(function () {
    window.open(ExternalUrlService/* ExternalUrlService.getDiscordLink */.b.getDiscordLink());
  }, []);
  var onClickPlayerManager = (0,react.useCallback)(function () {
    router.push(PagePathService/* PagePathService.playerManager */.v.playerManager());
  }, [router]);
  var onClickSupportCenter = (0,react.useCallback)(function () {
    window.open(ExternalUrlService/* ExternalUrlService.getSupportCenterLink */.b.getSupportCenterLink());
  }, []);
  var onClickAkvLink = (0,react.useCallback)(function () {
    return window.open(ExternalUrlService/* ExternalUrlService.getAkvLink */.b.getAkvLink());
  }, []);

  var onClickLogout = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return AuthService/* AuthService.logOut */.e.logOut();

            case 2:
              router.push(PagePathService/* PagePathService.login */.v.login());

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onClickLogout() {
      return _ref2.apply(this, arguments);
    };
  }();

  var onClickMyAkiverse = (0,react.useCallback)(function () {
    return router.push(PagePathService/* PagePathService.myPage */.v.myPage());
  }, [router]);
  var onClickBannerManager = (0,react.useCallback)(function () {
    return router.push(PagePathService/* PagePathService.adminBanner */.v.adminBanner());
  }, [router]);
  var onClickInterstitialBannerManager = (0,react.useCallback)(function () {
    return router.push(PagePathService/* PagePathService.adminInterstitialBanner */.v.adminInterstitialBanner());
  }, [router]);
  var onClickTournamentManager = (0,react.useCallback)(function () {
    return router.push(PagePathService/* PagePathService.tournamentBanner */.v.tournamentBanner());
  }, [router]);
  return {
    isAdmin: !!(loginUser !== null && loginUser !== void 0 && loginUser.isAdmin),
    akvBalance: akvBalance,
    onClickAkvLink: onClickAkvLink,
    onClickLogout: onClickLogout,
    onClickArcadeMachineManager: onClickArcadeMachineManager,
    onClickAkiverseWorld: onClickAkiverseWorld,
    onClickDiscord: onClickDiscord,
    onClickGameCenterManager: onClickGameCenterManager,
    onClickMyAkiverse: onClickMyAkiverse,
    onClickPlayerManager: onClickPlayerManager,
    onClickSupportCenter: onClickSupportCenter,
    onClickBannerManager: onClickBannerManager,
    onClickInterstitialBannerManager: onClickInterstitialBannerManager,
    onClickTournamentManager: onClickTournamentManager,
    activeMenu: activeMenu,
    disabled: disabled
  };
};
;// CONCATENATED MODULE: ./src/views/parts/commons/GlobalNavigationLayout/useProps.ts


var useProps = function useProps(_ref) {
  var children = _ref.children,
      activeMenu = _ref.activeMenu,
      disabled = _ref.disabled;
  return {
    GlobalNavigationHeaderProps: (0,GlobalNavigationHeader_useProps/* useProps */.w)(),
    GlobalNavigationMenuProps: useProps_useProps({
      activeMenu: activeMenu,
      disabled: disabled
    }),
    children: children
  };
};

/***/ }),

/***/ 4574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ RequiredAuthProvider; }
});

// UNUSED EXPORTS: Component

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/views/providers/AgreementProvider/index.tsx + 4 modules
var AgreementProvider = __webpack_require__(942);
// EXTERNAL MODULE: ./src/views/parts/bases/Center.tsx
var Center = __webpack_require__(4582);
// EXTERNAL MODULE: ./src/views/parts/bases/VStack.tsx
var VStack = __webpack_require__(2326);
// EXTERNAL MODULE: ./src/views/parts/buttons/PinkNeonButton.tsx
var PinkNeonButton = __webpack_require__(5167);
// EXTERNAL MODULE: ./src/views/parts/commons/Spinner.tsx
var Spinner = __webpack_require__(4974);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/services/PagePathService.ts
var PagePathService = __webpack_require__(19);
// EXTERNAL MODULE: ./src/services/LocalStorageService.ts + 1 modules
var LocalStorageService = __webpack_require__(830);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/views/providers/RequiredAuthProvider/Layout.tsx











var Layout = function Layout(_ref) {
  var children = _ref.children,
      type = _ref.type,
      onClickLogin = _ref.onClickLogin;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: type === 'LoggedIn' ? children : type === 'Loading' ? /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
      className: "h-full w-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
        visible: true,
        size: 40
      })
    }) : LocalStorageService/* LocalStorageService.loadAccountLock */.n.loadAccountLock() ? /*#__PURE__*/(0,jsx_runtime.jsx)(Redirecter, {
      path: PagePathService/* PagePathService.accountLocked */.v.accountLocked()
    }) : type === 'NO_Login' ? /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
      className: "h-full w-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
        className: "w-[500px] items-center rounded-2xl border-2 border-neon-blue bg-black bg-opacity-50 p-10",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          className: "mb-4 text-xl text-white",
          children: "Please login"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PinkNeonButton/* PinkNeonButton */.u, {
          onClick: onClickLogin,
          children: "Login Page"
        })]
      })
    }) : null
  });
};

var Redirecter = function Redirecter(props) {
  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    router.push(props.path);
  }, [router, props.path]);
  return null;
};
// EXTERNAL MODULE: ./src/views/states/LoginUser/index.tsx + 1 modules
var LoginUser = __webpack_require__(8655);
// EXTERNAL MODULE: ./src/views/states/FirebaseUser/index.tsx
var FirebaseUser = __webpack_require__(3855);
// EXTERNAL MODULE: ./src/services/AuthService.ts
var AuthService = __webpack_require__(746);
;// CONCATENATED MODULE: ./src/views/providers/RequiredAuthProvider/useProps.ts






var useProps = function useProps() {
  var _useFirebaseUser = (0,FirebaseUser/* useFirebaseUser */.I)(),
      firebaseUser = _useFirebaseUser.firebaseUser,
      isFirebaseLoading = _useFirebaseUser.isLoading;

  var _useLoginUser = (0,LoginUser/* useLoginUser */.x)(),
      isLoginUserLoading = _useLoginUser.isLoading,
      reload = _useLoginUser.reload,
      loginUser = _useLoginUser.loginUser;

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    reload();
  }, [reload]);
  return {
    type: loginUser && firebaseUser && AuthService/* AuthService.isLoggedIn */.e.isLoggedIn() ? 'LoggedIn' : isLoginUserLoading || isFirebaseLoading ? 'Loading' : 'NO_Login',
    onClickLogin: function onClickLogin() {
      return router.push(PagePathService/* PagePathService.login */.v.login());
    }
  };
};
;// CONCATENATED MODULE: ./src/views/providers/RequiredAuthProvider/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Component = function Component(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout, _objectSpread(_objectSpread({}, useProps()), {}, {
    children: children
  }));
};
var RequiredAuthProvider = function RequiredAuthProvider(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AgreementProvider/* AgreementProvider */.J, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      children: children
    })
  });
};

/***/ }),

/***/ 3076:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/akv.ad252dad.png","height":320,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEVMaXGFdZWUc5uGbo2qqKufmaKliKtEElSbRat0Xn6ysrOIfJJ3R4VdJG2ylLhMFV9sWHKpa7ZeEnCEa5ZqcW2SoZOkRrW8x7rBVdGqj7GNiZKDX4t1aHl8aImCgoTBjMnGmM3Jncm0AAAAGnRSTlMAc4mL+/u3EChz/v3+/rz8cv75dPr9/P38ugokPZMAAAAJcEhZcwAAFiUAABYlAUlSJPAAAABGSURBVAiZDctHFoAgDAXATwkhVLs+rPc/Jc5+APhSPADW4f2sYUjbj21tgrlRqssjULHmPF0CdadI4zmADdlgNQPwzv29A3AxAt1snRZJAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 7885:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/iconArcade.d08f32dc.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEVMaXH////////////////////////////////////////////////////m1kuZAAAADXRSTlMAQOFvU6fszpcXkCCwEtd3WwAAAAlwSFlzAAAhOAAAITgBRZYxYAAAADZJREFUCJktyUkKwDAMALHx7qb1/79bDLkJBFIdH4A72LOwC+nTsXV0VAWwqcx3azx0Syan4AcgJgD2T5OADAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ })

}]);